"use strict";

exports.__esModule = true;
exports["default"] = Info;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Info(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "-245.5 456.5 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.563 457.5c-140.634 0-255.063 114.459-255.063 255.033 0 140.601 114.429 254.967 255.063 254.967 140.604 0 254.937-114.366 254.937-254.967C265.5 571.959 151.167 457.5 10.563 457.5zm35.579 405.143h-71.748V656.97h71.748v205.673zM10.5 632.997c-21.914 0-40.681-15.093-40.681-38.413 0-23.747 18.767-38.848 40.681-38.848 21.948 0 40.685 15.101 40.685 38.848 0 23.32-18.737 38.413-40.685 38.413z"
  }));
}